import { useEffect, useRef, useState } from "react";

/**
 * Count up from 0 to `value` when it changes.
 * Renders via a formatter so we can use INR / integer / decimals.
 */
export default function CountUp({ value = 0, duration = 900, formatter = (v) => String(Math.round(v)) }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(value);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const to = Number(value) || 0;
    const from = fromRef.current;
    if (from === to) {
      setDisplay(to);
      return;
    }
    startRef.current = null;

    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const t = Math.min(1, elapsed / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const cur = from + (to - from) * eased;
      setDisplay(cur);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        fromRef.current = to;
      }
    };
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  return <>{formatter(display)}</>;
}
